import { FC, useState } from "react";
import { Box, FormControlLabel, Radio, RadioGroup, Stack, Switch, useTheme } from "@mui/material";
import Text from "../../../_components/Text";
import CustomPaper from "../../../_components/CustomPaper";
import DottedTextField from "../../../_components/DottedTextField";

function getLastDayOfMonth(next?: boolean): string {
	const date = new Date();

	if (next) {
		date.setMonth(date.getMonth() + 1);
	}

	date.setDate(0);
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();

	return `${day}.${month}.${year}`;
}

interface Props {
	fee: string
}

const InsuranceCostEstimation: FC<Props> = ({ fee }) => {
	const theme = useTheme();

	const [durationValue, setDurationValue] = useState<string>("0");
	const handleChange = (value: string) => setDurationValue(value);

	return (
		<CustomPaper
			label="Cost Estimation"
			labelVariant="regular"
			color={theme.myTheme.colors.gray500}
		>
			<Stack
				paddingTop={1}
				direction="column"
				sx={{ width: "100%" }}
				justifyContent={"space-between"}
				spacing={1}
			>
				<Box>
					<Text variant="s" color={theme.myTheme.colors.foreground50}>
						Your estimated insurance cost is calculated based on the selected coverage level and duration.
					</Text>
				</Box>
				<DottedTextField placeholder={"Estimated fee"} value={`${fee}`} />
			</Stack>
		</CustomPaper>
	);
};

export default InsuranceCostEstimation;
